/* eslint-disable */
import address_display from './address_display.vue';
import boolean_field_display from './boolean_field_display.vue';
import checkbox_display from './checkbox_display.vue';
import conditional_value_field_display from './conditional_value_field_display.vue';
import currency_field_display from './currency_field_display.vue';
import date_field_display from './date_field_display.vue';
import email_field_display from './email_field_display.vue';
import signature_field_display from './signature_field_display.vue';
import holidays_field_display from './holidays_field_display.vue';
import likert_answer_display from './likert_answer_display.vue';
import math_function_field_display from './math_function_field_display.vue';
import participant_field_display from './participant_field_display.vue';
import phone_number_field_display from './phone_number_field_display.vue';
import radio_display from './radio_display.vue';
import relationship_field_display from './relationship_field_display.vue';
import section_label_display from './section_label_display.vue';
import text_display from './text_display.vue';
import textarea_display from './textarea_display.vue';
import time_entry_field_display from './time_entry_field_display.vue';
import upload_field_display from './upload_field_display.vue';
import users_field_display from './users_field_display.vue';
import uri_field_display from './uri_field_display.vue';
import value_display from './value_display.vue';
import field_group_display from './field_group_display.vue';
export default {
  components: {
    address_display,
    boolean_field_display,
    checkbox_display, radio_display,
    conditional_value_field_display,
    currency_field_display,
    date_field_display,
    email_field_display,
    signature_field_display,
    holidays_field_display,
    likert_answer_display,
    math_function_field_display,
    phone_number_field_display,
    relationship_field_display, participant_field_display, users_field_display,
    section_label_display,
    text_display,
    textarea_display,
    time_entry_field_display,
    upload_field_display,
    uri_field_display,
    value_display,
    field_group_display,
  },
};